import type { ImportStage } from '@palaccount/contracts';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

/**
 * PUR-06 §4's stage pill. Colour carries the same message as the word so the
 * list is scannable, but the word is always present — colour alone is not an
 * accessible status (PART 4 §4.11).
 */
const TONE: Record<ImportStage, string> = {
  draft: 'bg-muted text-muted-foreground',
  confirmed: 'bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-200',
  shipped: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-950 dark:text-indigo-200',
  in_transit: 'bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-200',
  customs_clearance: 'bg-orange-100 text-orange-800 dark:bg-orange-950 dark:text-orange-200',
  received: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-200',
  closed: 'bg-slate-200 text-slate-700 dark:bg-slate-800 dark:text-slate-200',
  // Wave 5E — terminal, off the rail.
  cancelled: 'bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-200',
};

export function StageChip({ stage, className }: { stage: ImportStage; className?: string }) {
  const { t } = useTranslation();
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        TONE[stage],
        className,
      )}
    >
      {t(`imports.stage_${stage}`)}
    </span>
  );
}
